 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","certificate-certificate-module":"certificate-certificate-module","pages-account-account-module":"pages-account-account-module","pages-buy-certificate-login-buy-certificate-login-module":"pages-buy-certificate-login-buy-certificate-login-module","pages-clarification-clarification-module":"pages-clarification-clarification-module","pages-confirm-code-confirm-code-module":"pages-confirm-code-confirm-code-module","pages-exchange-final-exchange-final-module":"pages-exchange-final-exchange-final-module","pages-exchange-first-exchange-first-module":"pages-exchange-first-exchange-first-module","pages-exchange-photos-exchange-photos-module":"pages-exchange-photos-exchange-photos-module","pages-forgot-forgot-module":"pages-forgot-forgot-module","pages-login-login-module":"pages-login-login-module","pages-payment-schedule-payment-schedule-module":"pages-payment-schedule-payment-schedule-module","pages-pre-approved-cities-pre-approved-cities-module":"pages-pre-approved-cities-pre-approved-cities-module","pages-pre-approved-pre-approved-module":"pages-pre-approved-pre-approved-module","pages-pre-approved-shops-pre-approved-shops-module":"pages-pre-approved-shops-pre-approved-shops-module","pages-register-register-module":"pages-register-register-module","pages-schedule-details-schedule-details-module":"pages-schedule-details-schedule-details-module","tests-camera-front-camera-front-module":"tests-camera-front-camera-front-module","default~device-view-device-view-module~home-home-module~pages-approved-devices-approved-devices-modu~5dc32939":"default~device-view-device-view-module~home-home-module~pages-approved-devices-approved-devices-modu~5dc32939","pages-buy-service-uz-buy-service-uz-module":"pages-buy-service-uz-buy-service-uz-module","pages-card-detail-card-detail-module":"pages-card-detail-card-detail-module","pages-confirm-transfer-confirm-transfer-module":"pages-confirm-transfer-confirm-transfer-module","pages-exchange-exchange-module":"pages-exchange-exchange-module","pages-price-buy-service-price-buy-service-module":"pages-price-buy-service-price-buy-service-module","pages-transfer-funds-transfer-funds-module":"pages-transfer-funds-transfer-funds-module","default~device-view-device-view-module~pages-buy-service-buy-service-module~pages-device-report-devi~2bc746f2":"default~device-view-device-view-module~pages-buy-service-buy-service-module~pages-device-report-devi~2bc746f2","device-view-device-view-module":"device-view-device-view-module","pages-device-report-device-report-module":"pages-device-report-device-report-module","pages-buy-service-buy-service-module":"pages-buy-service-buy-service-module","pages-devices-report-devices-report-module":"pages-devices-report-devices-report-module","default~pages-credit-statement-credit-statement-module~pages-incomes-insights-incomes-insights-module":"default~pages-credit-statement-credit-statement-module~pages-incomes-insights-incomes-insights-module","pages-incomes-insights-incomes-insights-module":"pages-incomes-insights-incomes-insights-module","pages-credit-statement-credit-statement-module":"pages-credit-statement-credit-statement-module","default~pages-device-add-device-add-module~pages-find-imei-find-imei-module":"default~pages-device-add-device-add-module~pages-find-imei-find-imei-module","pages-device-add-device-add-module":"pages-device-add-device-add-module","pages-approved-devices-approved-devices-module":"pages-approved-devices-approved-devices-module","pages-devices-devices-module":"pages-devices-devices-module","pages-history-history-module":"pages-history-history-module","pages-in-progress-in-progress-module":"pages-in-progress-in-progress-module","pages-kts-devices-kts-devices-module":"pages-kts-devices-kts-devices-module","pages-kts-exchange-devices-kts-exchange-devices-module":"pages-kts-exchange-devices-kts-exchange-devices-module","pages-kts-packages-kts-packages-module":"pages-kts-packages-kts-packages-module","pages-kts-payment-devices-kts-payment-devices-module":"pages-kts-payment-devices-kts-payment-devices-module","pages-my-services-my-services-module":"pages-my-services-my-services-module","pages-onboarding-onboarding-module":"pages-onboarding-onboarding-module","pages-refund-devices-refund-devices-module":"pages-refund-devices-refund-devices-module","pages-rejection-devices-rejection-devices-module":"pages-rejection-devices-rejection-devices-module","pages-return-certificate-return-certificate-module":"pages-return-certificate-return-certificate-module","tests-connection-bluetooth-connection-bluetooth-module":"tests-connection-bluetooth-connection-bluetooth-module","tests-connection-cellular-connection-cellular-module":"tests-connection-cellular-connection-cellular-module","tests-connection-gps-connection-gps-module":"tests-connection-gps-connection-gps-module","tests-connection-wifi-connection-wifi-module":"tests-connection-wifi-connection-wifi-module","tests-hardware-charger-hardware-charger-module":"tests-hardware-charger-hardware-charger-module","tests-sensor-accelerometer-sensor-accelerometer-module":"tests-sensor-accelerometer-sensor-accelerometer-module","tests-sensor-compass-sensor-compass-module":"tests-sensor-compass-sensor-compass-module","tests-sensor-gyroscope-sensor-gyroscope-module":"tests-sensor-gyroscope-sensor-gyroscope-module","pages-certificates-modal-certificates-modal-module":"pages-certificates-modal-certificates-modal-module","pages-checkout-checkout-module":"pages-checkout-checkout-module","pages-contact-us-contact-us-module":"pages-contact-us-contact-us-module","pages-faqs-faqs-module":"pages-faqs-faqs-module","pages-notifications-details-notifications-details-module":"pages-notifications-details-notifications-details-module","pages-notifications-notifications-module":"pages-notifications-notifications-module","pages-payment-details-payment-details-module":"pages-payment-details-payment-details-module","pages-payments-payments-module":"pages-payments-payments-module","pages-personal-terms-personal-terms-module":"pages-personal-terms-personal-terms-module","pages-refund-refund-module":"pages-refund-refund-module","pages-tabs-tabs-module":"pages-tabs-tabs-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","tests-camera-flash-camera-flash-module":"tests-camera-flash-camera-flash-module","tests-camera-rear-camera-rear-module":"tests-camera-rear-camera-rear-module","tests-hardware-buttons-hardware-buttons-module":"tests-hardware-buttons-hardware-buttons-module","tests-hardware-fingerprint-hardware-fingerprint-module":"tests-hardware-fingerprint-hardware-fingerprint-module","tests-hardware-light-sensor-hardware-light-sensor-module":"tests-hardware-light-sensor-hardware-light-sensor-module","tests-hardware-proximity-hardware-proximity-module":"tests-hardware-proximity-hardware-proximity-module","tests-hardware-vibration-hardware-vibration-module":"tests-hardware-vibration-hardware-vibration-module","tests-screen-sensor-screen-sensor-module":"tests-screen-sensor-screen-sensor-module","tests-sound-headphones-sound-headphones-module":"tests-sound-headphones-sound-headphones-module","tests-sound-mic-sound-mic-module":"tests-sound-mic-sound-mic-module","tests-sound-speaker-loud-sound-speaker-loud-module":"tests-sound-speaker-loud-sound-speaker-loud-module","tests-sound-speaker-sound-speaker-module":"tests-sound-speaker-sound-speaker-module","swiper-bundle-6c5e7804-js":"swiper-bundle-6c5e7804-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-ce03ee9f-js":"input-shims-ce03ee9f-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-9cb487b1-js":"status-tap-9cb487b1-js","swipe-back-1bbd08e0-js":"swipe-back-1bbd08e0-js","tap-click-7ddcdebb-js":"tap-click-7ddcdebb-js","home-home-module":"home-home-module","settings-settings-module":"settings-settings-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
